/* Fitballz v2 UI: smooth scroll, reveals, the six, zones, gallery, buy bar, 3D loader. */
(() => {
  const d = document, root = d.documentElement;
  const me = d.currentScript;
  const MOD3D = me && me.dataset.three ? me.dataset.three : 'assets/js/fz-3d.js';
  const BASE = me && me.dataset.base ? me.dataset.base : 'assets/';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => [...c.querySelectorAll(s)];
  const hasGsap = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
  if (hasGsap) gsap.registerPlugin(ScrollTrigger);

  /* smooth scroll on desktop only, synced with ScrollTrigger */
  let lenis = null;
  if (!reduce && fine && window.Lenis) {
    lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 1 });
    if (hasGsap) {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(t => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
    } else {
      const loop = t => { lenis.raf(t); requestAnimationFrame(loop); };
      requestAnimationFrame(loop);
    }
    $$('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
      const t = $(a.getAttribute('href'));
      if (t) { e.preventDefault(); lenis.scrollTo(t, { offset: -10, duration: 1.4 }); }
    }));
  }

  /* header */
  const hdr = $('#hdr');
  const onScrollHdr = () => hdr.classList.toggle('solid', scrollY > 24);
  addEventListener('scroll', onScrollHdr, { passive: true }); onScrollHdr();

  /* reveals */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  $$('[data-reveal]').forEach(el => io.observe(el));

  /* the six: scroll progress picks the piece */
  const six = $('#six'), pieces = $$('.piece'), sixN = $('#six-n'), sixBar = $('#six-bar');
  let sixIdx = 0;
  const setSix = i => {
    if (i === sixIdx) return; sixIdx = i;
    pieces.forEach((p, k) => p.classList.toggle('on', k === i));
    sixN.textContent = String(i + 1).padStart(2, '0');
  };
  const sixProgress = () => {
    const r = six.getBoundingClientRect();
    const span = r.height - innerHeight;
    return span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
  };
  const onSix = () => {
    if (!six || !root.classList.contains('has3d')) return;
    const p = sixProgress();
    setSix(Math.min(5, Math.floor(p * 6)));
    sixBar.style.transform = `scaleX(${p})`;
  };
  addEventListener('scroll', onSix, { passive: true });

  /* why: words light up as you scroll */
  const why = $('#why');
  if (why) {
    $$('span', why).forEach(line => {
      const hot = line.querySelector('.hot-word');
      const text = line.textContent;
      line.textContent = '';
      text.split(' ').forEach((w, k, arr) => {
        const s = d.createElement('span');
        s.className = 'w' + (hot && w.startsWith('six') ? ' hot' : '');
        s.textContent = w + (k < arr.length - 1 ? ' ' : '');
        line.appendChild(s);
      });
    });
    const words = $$('.w', why);
    const lightWhy = () => {
      const r = why.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (innerHeight * 0.85 - r.top) / (r.height + innerHeight * 0.35)));
      const n = Math.round(p * words.length);
      words.forEach((w, k) => w.classList.toggle('lit', k < n));
    };
    if (reduce) words.forEach(w => w.classList.add('lit'));
    else { addEventListener('scroll', lightWhy, { passive: true }); lightWhy(); }
  }

  /* marquee leans with scroll speed */
  const mq = $('#mq');
  if (mq && hasGsap && !reduce) {
    const skew = gsap.quickTo(mq, 'skewX', { duration: 0.5, ease: 'power3' });
    let last = scrollY, lastT = performance.now();
    addEventListener('scroll', () => {
      const now = performance.now(), v = (scrollY - last) / Math.max(1, now - lastT);
      last = scrollY; lastT = now;
      skew(Math.max(-10, Math.min(10, v * -4)));
      clearTimeout(mq._t); mq._t = setTimeout(() => skew(0), 120);
    }, { passive: true });
  }

  /* pain to fix scenes: scroll moves through 5 body areas; each starts as the problem and turns into the fix */
  const rel = $('#zones'), copies = $$('.rc'), models = $$('.rm'), figs = copies, rtabs = $$('.relief .tab');
  let relIdx = -1, tapped = -1;
  const relProgress = () => { const r = rel.getBoundingClientRect(), span = r.height - innerHeight; return span > 0 ? Math.min(.9999, Math.max(0, -r.top / span)) : 0; };
  const setRel = () => {
    if (!rel || !figs.length) return;
    const n = figs.length, p = relProgress() * n, i = Math.min(n - 1, Math.floor(p)), frac = p - i;
    if (i !== relIdx) {
      relIdx = i; tapped = -1;
      copies.forEach((c, k) => c.classList.toggle('on', k === i));
      models.forEach((m, k) => m.classList.toggle('on', k === i));
      rtabs.forEach((t, k) => t.setAttribute('aria-pressed', String(k === i)));
    }
    rel.classList.toggle('solved', frac > 0.38 || tapped === i);
  };
  const goScene = k => {
    const r = rel.getBoundingClientRect(), span = r.height - innerHeight, y = scrollY + r.top + span * ((k + 0.55) / figs.length);
    if (lenis) lenis.scrollTo(y, { duration: 1.1 }); else scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  };
  if (rel) {
    addEventListener('scroll', setRel, { passive: true }); setRel();
    rtabs.forEach((t, k) => t.addEventListener('click', () => goScene(k)));
    $$('.relief .ring, .rm .pain').forEach(b => b.addEventListener('click', () => { tapped = relIdx; rel.classList.add('solved'); }));
  }

  /* real use strip: pinned horizontal scroll on desktop, swipe on phones */
  const strip = $('#strip'), track = $('#strip-track');
  const wide = matchMedia('(min-width: 900px) and (pointer: fine)');
  const sizeStrip = () => {
    if (!strip || !track) return;
    if (wide.matches && !reduce) {
      strip.classList.add('pinned');
      const extra = Math.max(0, track.scrollWidth - innerWidth + 80);
      strip.style.height = (innerHeight + extra) + 'px'; strip._extra = extra;
    } else { strip.classList.remove('pinned'); strip.style.height = ''; track.style.transform = ''; strip._extra = 0; }
  };
  const moveStrip = () => {
    if (!strip || !strip._extra) return;
    const r = strip.getBoundingClientRect(), span = r.height - innerHeight;
    const p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
    track.style.transform = `translate3d(${-p * strip._extra}px,0,0)`;
  };
  if (strip) { addEventListener('load', () => { sizeStrip(); moveStrip(); }); addEventListener('resize', () => { sizeStrip(); moveStrip(); }); addEventListener('scroll', moveStrip, { passive: true }); sizeStrip(); }

  /* videos load and play only while on screen */
  const vio = new IntersectionObserver(es => es.forEach(e => {
    const v = e.target;
    if (e.isIntersecting) { if (!v.src && v.dataset.src) v.src = v.dataset.src; if (!reduce && !v._drag) v.play().catch(() => {}); }
    else v.pause();
  }), { rootMargin: '200px 0px' });
  $$('video[data-src]').forEach(v => vio.observe(v));

  /* spin: drag sideways to turn the real set */
  const spin = $('#spin');
  if (spin) {
    const v = spin.querySelector('video'); let x0 = 0, t0 = 0, down = false, resume;
    spin.addEventListener('pointerdown', e => { if (!v.duration) return; down = true; v._drag = true; v.pause(); x0 = e.clientX; t0 = v.currentTime; clearTimeout(resume); spin.style.cursor = 'grabbing'; });
    addEventListener('pointermove', e => { if (!down) return; const d = v.duration; let t = t0 + ((e.clientX - x0) / spin.clientWidth) * d * 1.4; t = ((t % d) + d) % d; v.currentTime = t; });
    addEventListener('pointerup', () => { if (!down) return; down = false; spin.style.cursor = ''; resume = setTimeout(() => { v._drag = false; if (!reduce) v.play().catch(() => {}); }, 1400); });
  }

  /* gallery + thumbs (only when a gallery exists) */
  if ($('#gal') && $('#thumbs')) {
  const gal = $('#gal'), thumbs = $('#thumbs');
  const slides = gal ? [...gal.children] : [];
  slides.forEach((im, k) => {
    const b = d.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', `Image ${k + 1}`);
    if (k === 0) b.setAttribute('aria-current', 'true');
    const t = d.createElement('img');
    const vid = im.querySelector && im.querySelector('video');
    t.src = vid ? vid.getAttribute('poster') : (im.currentSrc || im.src); t.alt = ''; t.loading = 'lazy'; b.appendChild(t);
    b.addEventListener('click', () => gal.scrollTo({ left: im.offsetLeft - gal.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }));
    thumbs.appendChild(b);
  });
  const tb = $$('button', thumbs);
  gal.addEventListener('scroll', () => {
    const k = Math.round(gal.scrollLeft / gal.clientWidth);
    tb.forEach((b, j) => b.setAttribute('aria-current', String(j === k)));
  }, { passive: true });
  }

  /* quantity: a Shopify form input when present, otherwise the cart link */
  let q = 1;
  const qv = $('#qv'), buyCta = $('#buy-cta'), qIn = $('#fz-qty');
  const setQ = n => {
    q = Math.max(1, Math.min(10, n)); qv.textContent = q;
    if (qIn) qIn.value = q;
    else if (buyCta && buyCta.dataset.variant) buyCta.href = `https://www.fitballz.com/cart/${buyCta.dataset.variant}:${q}`;
  };
  if (qv) { $('#qm').addEventListener('click', () => setQ(q - 1)); $('#qp').addEventListener('click', () => setQ(q + 1)); }

  /* sticky buy bar: shows once the hero button is gone and hides over the buy box */
  const sbar = $('#sbar');
  if (sbar) {
  const vis = { hero: true, buy: false };
  const sio = new IntersectionObserver(es => {
    es.forEach(e => { vis[e.target.id === 'hero-cta' ? 'hero' : 'buy'] = e.isIntersecting; });
    const on = !vis.hero && !vis.buy;
    sbar.classList.toggle('on', on); sbar.setAttribute('aria-hidden', String(!on));
    const sb = sbar.querySelector('a,button'); if (sb) sb.tabIndex = on ? 0 : -1;
  });
  const heroCta = $('#hero-cta'), buySec = $('#buy');
  if (heroCta) sio.observe(heroCta); else vis.hero = false;
  if (buySec) sio.observe(buySec);
  }

  /* magnetic buttons */
  if (fine && !reduce) $$('.magnet').forEach(b => {
    b.addEventListener('pointermove', e => {
      const r = b.getBoundingClientRect();
      const x = (e.clientX - r.left - r.width / 2) * 0.18, y = (e.clientY - r.top - r.height / 2) * 0.3;
      b.style.transform = `translate(${x}px,${y}px)`;
    });
    b.addEventListener('pointerleave', () => { b.style.transform = ''; });
  });

  /* 3D: only with WebGL, motion allowed, after first paint */
  const hint = $('.hint-txt'); if (hint && !fine) hint.textContent = 'Tap a ball';
  if (reduce || !window.WebGLRenderingContext || !six || !$('#land-img')) { root.classList.add('no3d'); return; }
  /* 3D starts after the page has loaded and the browser is idle, so the packshot and the headline paint first (LCP). Without WebGL the static fallback stays. */
  const boot = () => import(new URL(MOD3D, location.href).href).then(m => m.start({
    canvas: $('#fz3d'),
    stages: { hero: $('#stage-hero'), six: $('#stage-six'), sixSection: six, land: $('#land-img'), landSection: $('#land'), shot: $('#shot'),
      relief: $('#stage-relief'), reliefSection: rel, buy: $('#stage-buy'), buySection: $('#buy') },
    getRelief: () => ({ i: Math.max(0, relIdx), solved: !!(rel && rel.classList.contains('solved')) }),
    tex: { disc: me.dataset.texDisc, plain: me.dataset.texPlain, peanut: me.dataset.texPeanut },
    threeUrl: new URL(me.dataset.threeLib, location.href).href,
    getSix: () => sixIdx,
    onReady: () => { root.classList.add('has3d'); onSix(); if (hasGsap) ScrollTrigger.refresh(); }
  })).catch(err => { console.warn('3D off:', err); root.classList.add('no3d'); });
  const start = () => ('requestIdleCallback' in window ? requestIdleCallback(boot, { timeout: 2500 }) : setTimeout(boot, 1200));
  if (d.readyState === 'complete') start(); else addEventListener('load', start, { once: true });
})();
